export const META_CONSENT_KEY = "sfm_meta_consent_v1";

const listeners = new Set();
let visitChoice = null;
let storageUnavailable = false;
const validChoice = (value) => value === "accepted" || value === "rejected" ? value : null;

export function getMetaConsent() {
  if (storageUnavailable) return visitChoice;
  try {
    return validChoice(window.localStorage.getItem(META_CONSENT_KEY));
  } catch {
    return visitChoice;
  }
}

export function setMetaConsent(choice) {
  if (!validChoice(choice)) return false;
  visitChoice = choice;
  try {
    window.localStorage.setItem(META_CONSENT_KEY, choice);
    storageUnavailable = false;
  } catch {
    // An explicit choice still applies to this visit if storage is disabled.
    storageUnavailable = true;
  }
  listeners.forEach((listener) => listener());
  return !storageUnavailable;
}

function onStorage(event) {
  if (event.key !== META_CONSENT_KEY && event.key !== null) return;
  if (event.storageArea && event.storageArea !== window.localStorage) return;
  visitChoice = null;
  storageUnavailable = false;
  listeners.forEach((listener) => listener());
}

export function subscribeMetaConsent(listener) {
  if (listeners.size === 0) window.addEventListener("storage", onStorage);
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) window.removeEventListener("storage", onStorage);
  };
}